export class Menu {
    constructor() {
        this.toggleMenu();
        this.toggleDropdown();
    }

    toggleMenu() {
        const hamburger = document.querySelector('.hamburger');
        const sideNav = document.querySelector('.sidenav');
        const closeSideNavBtn = document.querySelector('.sidenav__close');

        hamburger.addEventListener('click', () => {
            hamburger.classList.add('is-active');
            sideNav.classList.add('is-active');
        });

        closeSideNavBtn.addEventListener('click', () => {
           sideNav.classList.remove('is-active');
           hamburger.classList.remove('is-active');
        });

        document.addEventListener('keyup', (e) => {
           if (e.key === 'Escape') {
               sideNav.classList.remove('is-active');
               hamburger.classList.remove('is-active');
           }
        });
    }

    toggleDropdown() {
        const allDropdown = $('.dropdown-menu').hide();
        const allMenuItems = $('.menu__item.has-dropdown');
        const allMenuLinks = $('.menu__item.has-dropdown > .menu__link');
        const allDropdownLinks = $('.dropdown-menu__item.has-dropdown > .dropdown-menu__link');

        allMenuLinks.click(function(e) {
            e.preventDefault();
            let $this = $(this);
            let $target = $this.next();

            if ($target.hasClass('active')) {
                $target.parent().removeClass('is-active');
                $target.removeClass('active').slideUp('fast');
            } else {
                allDropdown.removeClass('active').slideUp('fast');
                allMenuItems.removeClass('is-active');
                $target.parent().addClass('is-active');
                $target.addClass('active').slideDown('fast');
            }

            return false;
        });

        allDropdownLinks.click(function(e) {
            e.preventDefault();
            let $this = $(this);
            let $target = $this.next();
            $target.slideToggle('fast');
        });
    }
}